import { render } from "./HandbookList.vue?vue&type=template&id=4d2f9b60"
import script from "./HandbookList.vue?vue&type=script&lang=js"
export * from "./HandbookList.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__